import { render, staticRenderFns } from "./InlineConflictTable.vue?vue&type=template&id=3ed9bd6f&"
import script from "./InlineConflictTable.vue?vue&type=script&lang=js&"
export * from "./InlineConflictTable.vue?vue&type=script&lang=js&"
import style0 from "./InlineConflictTable.vue?vue&type=style&index=0&id=3ed9bd6f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports